
import { useApartmentOptions } from '../../features/admin/option/ApartmentOption'
import CommonTermAndCondtion from '../../features/commonfile/CommonTermAndCondtion'



const ZonalCoordinatorTCPage = () => {
const {allApartmentOption}=useApartmentOptions()

  return (
    <CommonTermAndCondtion apartmentRow={allApartmentOption?.options}/>
  )
}

export default ZonalCoordinatorTCPage